/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".license-usage-information[_ngcontent-%COMP%]{padding:0 10px;display:flex;align-items:center;font-size:14px}.license-usage-information[_ngcontent-%COMP%]   .usage-prefix[_ngcontent-%COMP%]{padding-right:.5em}.license-icon[_ngcontent-%COMP%]{font-size:20px;line-height:22px}"];
export { styles as styles };
